import { IUpdateEntregaObrasClienteArquivoUseCase } from "../../../presentation/useCases/update/update_entrega_obras_cliente_arquivo_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * UpdateEntregaObrasClienteArquivoUseCase
 */

export class UpdateEntregaObrasClienteArquivoUseCase implements IUpdateEntregaObrasClienteArquivoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idEntregaObraClienteArquivo: number,
    idEntregaObra: number,
    descricao?: string,
    arquivo?: File,
    limparArquivo?: boolean
  ): Promise<void> {
    const computedArquivoNome = limparArquivo ? null : arquivo?.name;
    const computedArquivo = limparArquivo ? null : arquivo;

    await this.repository.updateEntregaObrasClienteArquivos(
      idEntregaObraClienteArquivo,
      idEntregaObra,
      computedArquivoNome ? computedArquivoNome : undefined,
      descricao,
      computedArquivo ? computedArquivo : undefined,
      limparArquivo
    );
  }
}
